import { APP_LOAD, LOGOUT } from '../constants/actionTypes';
const defaultState = [
  {
    name: "live",
    columns: [
      {
        name: "groom",
        label: "Groom's Name",
        type: "string",
        placeholder: "Please enter first name of groom"
      },
      {
        name: "bride",
        label: "Bride's Name",
        type: "string",
        placeholder: "Please enter first name of bride"
      },
      {
        name: "weddingLocation",
        label: "Wedding Location",
        type: "string",
        placeholder: "Please enter wedding location"
      },
      {
        name: "weddingMapLocation",
        label: "Wedding Map Location",
        type: "string",
        placeholder: "Please enter address that can give correct location in Google map"
      },
      {
        name: "engagementLocation",
        label: "Engagement Location",
        type: "string",
        placeholder: "Please enter engagement location"
      },
      {
        name: "engagementMapLocation",
        label: "Engagement Map Location",
        type: "string",
        placeholder: "Please enter address that can give correct location in Google map"
      },
      {
        name: "weddingDatetime",
        label: "Wedding Date & Time",
        type: "timestamp",
        placeholder: "Please enter date and time of wedding in YYYY-MM-DDTHH:MM:00Z format"
      },
      {
        name: "engagementDatetime",
        label: "Engagement Date & Time",
        type: "timestamp",
        placeholder: "Please enter date and time of engagement in YYYY-MM-DDTHH:MM:00Z format"
      },
      {
        name: "weddingNote",
        label: "Wedding Food Note",
        type: "string",
        placeholder: "Defaults to -followed by lunch at Parish hall-"
      },
      {
        name: "engagementNote",
        label: "Engagement Food Note",
        type: "string",
        placeholder: "Defaults to -followed by lunch at Parish hall-"
      },
      {
        name: "secondEventTitle",
        label: "Name of second event",
        type: "string",
        placeholder: "Defaults to Betrothal. You can change to reception"
      },
      {
        name: "colorOverride",
        label: "HTML colorcode to use as background",
        type: "string",
        placeholder: "Defaults to f44482. Put ffffff for transparent. https://html-color-codes.info/"
      },
      {
        name: "groomPhoto",
        label: "Groom's Photo",
        type: "file",
        placeholder: "Please enter url of image. Or use upload option and copy message here"
      },
      {
        name: "bridePhoto",
        label: "Bride's Photo",
        type: "file",
        placeholder: "Please enter url of image. Or use upload option and copy message here"
      },
      {
        name: "couplePhoto",
        label: "Couple's Photo",
        type: "file",
        placeholder: "Please enter url of image. Or use upload option and copy message here"
      },
    ] 
  },
  {
    name: "live-single",
    columns: [
      {
        name: "groom",
        label: "Groom's Name",
        type: "string",
        placeholder: "Please enter first name of groom"
      },
      {
        name: "bride",
        label: "Bride's Name",
        type: "string",
        placeholder: "Please enter first name of bride"
      },
      {
        name: "weddingLocation",
        label: "Wedding Location",
        type: "string",
        placeholder: "Please enter wedding location"
      },
      {
        name: "weddingMapLocation",
        label: "Wedding Map Location",
        type: "string",
        placeholder: "Please enter address that can give correct location in Google map"
      },
      {
        name: "weddingDatetime",
        label: "Wedding Date & Time",
        type: "timestamp",
        placeholder: "Please enter date and time of wedding in YYYY-MM-DDTHH:MM:00Z format"
      },
      {
        name: "weddingNote",
        label: "Wedding Food Note",
        type: "string",
        placeholder: "Defaults to -followed by lunch at Parish hall-"
      },
      {
        name: "colorOverride",
        label: "HTML colorcode to use as background",
        type: "string",
        placeholder: "Defaults to f44482. Put ffffff for transparent. https://html-color-codes.info/."
      },
      {
        name: "groomPhoto",
        label: "Groom's Photo",
        type: "file",
        placeholder: "Please enter url of image. Or use upload option and copy message here"
      },
      {
        name: "bridePhoto",
        label: "Bride's Photo",
        type: "file",
        placeholder: "Please enter url of image. Or use upload option and copy message here"
      },
      {
        name: "couplePhoto",
        label: "Couple's Photo",
        type: "file",
        placeholder: "Please enter url of image. Or use upload option and copy message here"
      },
    ]
  },
  {
    name: "transparent",
    columns: [
      {
        name: "groom",
        label: "Groom's Name",
        type: "string",
        placeholder: "Please enter first name of groom"
      },
      {
        name: "bride",
        label: "Bride's Name",
        type: "string",
        placeholder: "Please enter first name of bride"
      },
      {
        name: "weddingLocation",
        label: "Wedding Location",
        type: "string",
        placeholder: "Please enter wedding location"
      },
      {
        name: "weddingMapLocation",
        label: "Wedding Map Location",
        type: "string",
        placeholder: "Please enter address that can give correct location in Google map"
      },
      {
        name: "engagementLocation",
        label: "Engagement Location",
        type: "string",
        placeholder: "Please enter engagement location"
      },
      {
        name: "engagementMapLocation",
        label: "Engagement Map Location",
        type: "string",
        placeholder: "Please enter address that can give correct location in Google map"
      },
      {
        name: "weddingDatetime",
        label: "Wedding Date & Time",
        type: "timestamp",
        placeholder: "Please enter date and time of wedding in YYYY-MM-DDTHH:MM:00Z format"
      },
      {
        name: "engagementDatetime",
        label: "Engagement Date & Time",
        type: "timestamp",
        placeholder: "Please enter date and time of engagement in YYYY-MM-DDTHH:MM:00Z format"
      },
      {
        name: "weddingNote",
        label: "Wedding Food Note",
        type: "string",
        placeholder: "Defaults to -followed by lunch at Parish hall-"
      },
      {
        name: "engagementNote",
        label: "Engagement Food Note",
        type: "string",
        placeholder: "Defaults to -followed by lunch at Parish hall-"
      },
      {
        name: "groomPhoto",
        label: "Groom's Photo",
        type: "file",
        placeholder: "Please enter url of image. Or use upload option and copy message here"
      },
      {
        name: "bridePhoto",
        label: "Bride's Photo",
        type: "file",
        placeholder: "Please enter url of image. Or use upload option and copy message here"
      },
      {
        name: "couplePhoto",
        label: "Couple's Photo",
        type: "file",
        placeholder: "Please enter url of image. Or use upload option and copy message here"
      },
    ]
  },
  {
    name: "transparent-single",
    columns: [
      {
        name: "groom",
        label: "Groom's Name",
        type: "string",
        placeholder: "Please enter first name of groom"
      },
      {
        name: "bride",
        label: "Bride's Name",
        type: "string",
        placeholder: "Please enter first name of bride"
      },
      {
        name: "weddingLocation",
        label: "Wedding Location",
        type: "string",
        placeholder: "Please enter wedding location"
      },
      {
        name: "weddingMapLocation",
        label: "Wedding Map Location",
        type: "string",
        placeholder: "Please enter address that can give correct location in Google map"
      },
      {
        name: "weddingDatetime",
        label: "Wedding Date & Time",
        type: "timestamp",
        placeholder: "Please enter date and time of wedding in YYYY-MM-DDTHH:MM:00Z format"
      },
      {
        name: "groomPhoto",
        label: "Groom's Photo",
        type: "file",
        placeholder: "Please enter url of image. Or use upload option and copy message here"
      },
      {
        name: "bridePhoto",
        label: "Bride's Photo",
        type: "file",
        placeholder: "Please enter url of image. Or use upload option and copy message here"
      },
      {
        name: "couplePhoto",
        label: "Couple's Photo",
        type: "file",
        placeholder: "Please enter url of image. Or use upload option and copy message here"
      },
    ]
  }
];

export default (state = defaultState, action) => {
  switch (action.type) {
    case APP_LOAD:
      return action.payload && action.payload.templates ? action.payload.templates : state;
    default:
      return state;
  }
};
